/** Convert a persisted Polymarket event slug (or pasted event URL) into the
 * canonical public event URL. Reject other hosts/schemes so DB content can
 * never become an unsafe link in the dashboard. */
export function polymarketEventUrl(value: string | null): string | null {
  const raw = value?.trim();
  if (!raw) return null;

  let slug = raw;
  try {
    const url = new URL(raw);
    const host = url.hostname.toLowerCase().replace(/^www\./, "");
    if (url.protocol !== "https:" || host !== "polymarket.com") return null;
    const match = /^\/event\/([^/]+)\/?$/.exec(url.pathname);
    if (!match) return null;
    slug = decodeURIComponent(match[1]!);
  } catch {
    slug = raw.replace(/^\/?event\//, "");
  }

  if (!/^[A-Za-z0-9][A-Za-z0-9_-]*$/.test(slug)) return null;
  return `https://polymarket.com/event/${encodeURIComponent(slug)}`;
}
